module.exports = __webpack_public_path__ + "img/img_brand_2.b73aa341.svg";